import { HsSphere } from '../../math-new/shapes/sphere.class';
import { HsCollider } from './collider.class';
import { HsVector3 } from '../../math-new/objects/vector3.class';

export class HsSphereCollider extends HsCollider {
  public shape: HsSphere;

  constructor(x: number, y: number, z: number, radius: number) {
    super();
    this.shape = new HsSphere(x, y, z, radius);
  }

  public setCenter(x: number, y: number, z: number): void {
    this.shape.center.set(x, y, z);
  }

  public getDistance(position: HsVector3): number {
    return HsVector3.distance(this.shape.center, position) - this.shape.radius;
  }

  public getNormal(position: HsVector3, target: HsVector3): HsVector3 {
    return target.copy(position).subtract(this.shape.center).normalize();
  }
}
